import React, { useEffect } from "react";
// import NavComponent from "./NavComponents"
// import { productsListing } from "./ProductsScroll";


// const CrowFran = require("../assets/images/crow-fran (2).png")
// export const products = ["Cluster Manager", "Inventory Manager", "Outlets Manager", "Extender"]
const Header = () => {
    useEffect(() => {
    }, []);

    return(
      <header id="header" className="header sticky-top">

      <div className="topbar position-relative d-flex align-items-center dark-background">
        <div className="container d-flex justify-content-center justify-content-md-between">
          <div className="contact-info d-flex align-items-center">
            <i className="bi bi-envelope d-flex align-items-center"><a href="mailto:contact@example.com">info@crowfran.tech</a></i>
            <i className="bi bi-phone d-flex align-items-center ms-4"><span>+234 905 695 6654</span></i>
            {/* <i className="bi bi-whatsapp d-flex align-items-center ms-4">

            </i> */}
          <a className="btn btn-getstarted" href={process.env.REACT_APP_WHATSAPP_NUM}><i className="bi bi-whatsapp "> Chat</i></a>


          </div>
          <div className="social-links d-none d-md-flex align-items-center">
            <a href="#" className="twitter"><i className="bi bi-twitter-x"></i></a>
            <a href="#" className="facebook"><i className="bi bi-facebook"></i></a>
            <a href="#" className="instagram"><i className="bi bi-instagram"></i></a>
            <a href="#" className="linkedin"><i className="bi bi-linkedin"></i></a>
          </div>
        </div>
      </div>
  
      {/* <div className="branding d-flex align-items-cente"> */}
  
        {/* <div className="container position-relative d-flex align-items-center justify-content-between"> */}
          {/* <a href="index.html" className="logo d-flex align-items-center"> */}
            {/* <!-- Uncomment the line below if you also wish to use an image logo -->
            <!-- <img src="assets/img/logo.png" alt=""> --> */}
            {/* <h1 className="sitename">Hotelace</h1> */}
          {/* </a> */}
          {/* <a className="btn btn-getstarted" href={process.env.REACT_APP_WHATSAPP_NUM}><i className="bi bi-whatsapp"> Chat</i></a> */}
  
          {/* <nav id="navmenu" className="navmenu">
            <ul>
              <li><a href="#hero" className="active">Home<br /></a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#portfolio">Portfolio</a></li>
              <li><a href="#team">Team</a></li>
              <li><a href="#pricing">Pricing</a></li>
              <li><a href="blog.html">Blog</a></li>
              <li className="dropdown"><a href="#"><span>Dropdown</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                <ul>
                  <li><a href="#">Dropdown 1</a></li>
                  <li className="dropdown"><a href="#"><span>Deep Dropdown</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                    <ul>
                      <li><a href="#">Deep Dropdown 1</a></li>
                      <li><a href="#">Deep Dropdown 2</a></li>
                      <li><a href="#">Deep Dropdown 3</a></li>
                      <li><a href="#">Deep Dropdown 4</a></li>
                      <li><a href="#">Deep Dropdown 5</a></li>
                    </ul>
                  </li>
                  <li><a href="#">Dropdown 2</a></li>
                  <li><a href="#">Dropdown 3</a></li>
                  <li><a href="#">Dropdown 4</a></li>
                </ul>
              </li>
              <li><a href="#contact">Contact</a></li>
            </ul>
            <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
          </nav> */}
  
        {/* </div> */}
  
      {/* // </div> */}
  
    </header>
    )
}


export default Header